"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MemberSecurityAction = void 0;
exports.mapMemberSecurityMessage = mapMemberSecurityMessage;
/** MEMBER_SECURITY (`mu`, 30061) — смена логина, e-mail, пароля и др. */
exports.MemberSecurityAction = {
    ResendActivation: 0,
    Activate: 1,
    SetEmail: 2,
    ConfirmEmail: 3,
    SetPassword: 4,
    RequestResetPassword: 5,
    ResetPassword: 6,
    SetLogin: 7,
};
const COMMON_MESSAGES = {
    4: 'Ссылка устарела',
    5: 'Неправильный адрес почты',
    6: 'Дублирование адреса почты',
    7: 'Неверный пароль',
};
const SET_LOGIN_MESSAGES = {
    7: 'Неверный пароль',
    9: 'Смену логина можно выполнять не чаще одного раза в год',
    10: 'Такой логин уже занят',
    11: 'Недопустимые символы в логине',
};
const SET_PASSWORD_MESSAGES = {
    7: 'Неверный пароль',
    8: 'Слишком короткий пароль',
};
function mapMemberSecurityMessage(status, action, fallback) {
    if (status === 0) {
        if (action === exports.MemberSecurityAction.RequestResetPassword
            || action === exports.MemberSecurityAction.ResendActivation) {
            return 'Письмо отправлено.';
        }
        if (action === exports.MemberSecurityAction.ResetPassword) {
            return 'Успешная смена пароля';
        }
        if (action === exports.MemberSecurityAction.Activate) {
            return 'Аккаунт активирован';
        }
        if (action === exports.MemberSecurityAction.ConfirmEmail) {
            return 'Успешная смена e-mail';
        }
        return 'Успешно';
    }
    if (status === 3)
        return 'Неправильный пользователь';
    if (action === exports.MemberSecurityAction.SetLogin && SET_LOGIN_MESSAGES[status]) {
        return SET_LOGIN_MESSAGES[status];
    }
    if ((action === exports.MemberSecurityAction.SetPassword || action === exports.MemberSecurityAction.ResetPassword)
        && SET_PASSWORD_MESSAGES[status]) {
        return SET_PASSWORD_MESSAGES[status];
    }
    if (COMMON_MESSAGES[status])
        return COMMON_MESSAGES[status];
    return fallback ?? `Ошибка (код ${status})`;
}
